import { useCallback } from 'react'

import { useLocale } from '@rewardops/ui/src/hooks/use-locale'

import { useApi } from './use-api'

export const useFormat = () => {
  const { tenant } = useApi()
  const { locale } = useLocale()

  const formatNumber = useCallback(
    (num?: number, maximumFractionDigits = 2) => {
      const isInteger = num !== undefined && num % 1 === 0
      return new Intl.NumberFormat(locale, {
        minimumFractionDigits: isInteger ? 0 : maximumFractionDigits,
        maximumFractionDigits,
      }).format(num || 0)
    },
    [locale],
  )

  const formatCurrency = useCallback(
    (amount?: number, currency: string = tenant.defaultCurrency) => {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(amount || 0)
    },
    [locale, tenant.defaultCurrency],
  )

  return { formatNumber, formatCurrency }
}
